/**
 * The application root.
 *
 * Thin on purpose: it starts the background sync loop and renders the shell. The startup ORDER is the
 * only thing here with a reason attached, and it is in `main.tsx`.
 */

import { useEffect } from 'react';
import { startSync } from './core/sync';
import { AppShell } from './ui/AppShell';

export function App(): JSX.Element {
  useEffect(() => {
    // Returns its own stop function, so React 18's StrictMode double-invoke in development tears the
    // first loop down instead of leaving two flushers and two intervals running.
    const stop = startSync();
    return stop;
  }, []);

  return <AppShell />;
}
